import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type ProgressDTO = {
  videosWatched: number;
  totalVideos: number;
  percentage: string;
};

interface ProgressData {
  progressData: ProgressDTO;
}
interface ProgressResponse {
  data?: ProgressData;
  error?: ApiError;
}

export const GetProgress = async (
  courseId: string
): Promise<ProgressResponse> => {
  try {
    const response = await axios.get(`/video/progress/${courseId}`);
    return { data: { progressData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
